import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import LandingPage from "./screens/LandingPage";
import HouseholdRegistration from "./screens/HouseholdRegistration";
import PackingPortal from "./screens/PackingPortal";
import VolunteerPortal from "./screens/VolunteerPortal";
import AdminDashboard from "./screens/AdminDashboard";
import OrderSubmission from "./screens/OrderSubmission";
import AccountCreate from "./screens/AccountCreate";
import AccountLogin from "./screens/AccountLogin";
import MyOrders from "./screens/MyOrders";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
    });
    return unsubscribe;
  }, []);

  if (user === undefined) return null;

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Public — no auth required */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/register" element={<HouseholdRegistration />} />
        <Route path="/order/:tokenId" element={<OrderSubmission />} />
        <Route path="/order" element={<OrderSubmission />} />
        <Route path="/account" element={<AccountCreate />} />
        <Route path="/login" element={<AccountLogin />} />
        <Route path="/my-orders" element={<MyOrders />} />

        {/* Protected — requires Firebase auth */}
        <Route path="/volunteer/packing" element={<PackingPortal />} />
        <Route path="/volunteer" element={<VolunteerPortal />} />
        <Route path="/admin" element={<AdminDashboard />} />

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
